import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorBase } from 'src/app/services/api/models';

@Component({
  selector: 'arsa-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {

  private items: PaginatorBase;

  get data(): PaginatorBase {
    return this.items;
  }
  @Input()
  set data(value: PaginatorBase) {
    this.items = value;
    console.log(this.items);

  }

  @Output('page')
  page: EventEmitter<number> = new  EventEmitter<number>();

  constructor() { }

  setPage(action) {
    let page = this.items.current_page;
    let aux = this.items.total / this.items.per_page;
    let lastPage = (aux > Math.trunc(aux)) ? Math.trunc(aux) + 1 : Math.trunc(aux);
    if (action == 'next' && page != lastPage) page++;
    if (action == 'previous' && page != 1) page--;
    if (action == 'first') page = 1;
    if (action == 'last') page = lastPage;

    this.page.next(page);
  }

}
